import { render, staticRenderFns } from "./SearchBarItemPatient.vue?vue&type=template&id=1a2ad60c&scoped=true"
import script from "./SearchBarItemPatient.vue?vue&type=script&lang=js"
export * from "./SearchBarItemPatient.vue?vue&type=script&lang=js"
import style0 from "./SearchBarItemPatient.vue?vue&type=style&index=0&id=1a2ad60c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ad60c",
  null
  
)

export default component.exports